class VaultEditModal {
  id: number;

  title: string;

  imageUrl: string;

  constructor(params?: VaultEditModalType) {
    this.id = params?.id || -1;
    this.title = params?.title || '';
    this.imageUrl = params?.coverUrl || '';
  }
}

export { VaultEditModal };
